import React from 'react'
import { Typography } from 'atoms/Typography'
import { cn } from 'ethcss'
import translate from 'core/translate'
import styles from './deviceSettings__ipTv.jcss'
import { SwitchButton } from '../../../atoms/SwitchButton'

export const IpTv = (p_: { enableIPTV: boolean; onChange: (value: boolean) => void; enabled: boolean }) => {
    return p_.enabled ? (
        <>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.enableIPTV}
                    onChange={() => {
                        p_.onChange(!p_.enableIPTV)
                    }}
                    className={`test-settings-toggle_${p_.enableIPTV ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography type="title">{translate('useIpTv')}</Typography>
                </div>
            </div>
        </>
    ) : null
}
